export enum DealerType_Enum {
    Unknown = 0,
    FranchiseDealer = 1,
    CarSupermarket = 2,
    NonFranchisedDealer = 3,
    FinanceHouse = 4
}